module.exports = __webpack_public_path__ + "img/fig27.583d161d.jpg";